import { createStore } from 'vuex'
const store = createStore({
    state:{
        globalResult:{
            "basic_info":{
                "OS":'',
                "Device(Model,Vendor)": '', 
                "Resolution": '', 
                "Browser Name": '', 
                "Browser Version": '', 
                "IP": '', 
                "Render Engine": '', 
                "UA":''
            },
            "video_codec":{
                "H265 Decode":'',
                "H264 Decode":'',
                "VP9 Decode":'',
                "VP8 Decode":'',
                "AAC Decode":'',
                "MP3 Decode":'',
                "H265 Encode":'',
                "H264 Encode":'',
                "VP9 Encode":'',
                "VP8 Encode":'',
                "AAC Encode":'',
                "MP3 Encode":'',
            },
            "image_codec":{
                "JPEG Decode":'',
                "PNG Decode":'',
                "GIF Decode":'',
                "WEBP Decode":''
            },
            "domain":[]
            },
            activeIndex:1,    

    },
    mutations:{
        setGlobalResult(state,result){
            state.globalResult = result;
        },
        setActiveIndex(state,result){
            state.activeIndex = result
        }
    },
});

export default store;